module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Add-user-329822397ee479e095d868ed6ef7e4c7.svg";